/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */

function LinkFormController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var form;
	var shortLinkField;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function showAlert(message) {
		alert(message);
	}


	function initFormHandler() {
		// submit
		form.on('beforeSubmit', function () {
			$.post(form.attr('action'), form.serialize(), function(response) {
				if(response.success) {
					onFormSendSuccess(response);
				} else {
					onFormSendError(response.errors);
				}
			});			
			
			return false;
		});
	}

	
	function onFormSendSuccess(response){
		$('.state.form').hide();
		$('.state.result').show();
		
		if(response.shortUrl) {
			shortLinkField.val(response.shortUrl);
			shortLinkField.focus();
			shortLinkField.select();
		}
	
		_this.resetForm();
	}	

	
	function onFormSendError(errors){
		showAlert('Error while sending form.');
	}
	
	
	function initClipboardHandler(){
		var clipboard = new ClipboardJS('.copyToClipboard');
		var copyStatus = $('.copyStatus', _this.container);
		
		clipboard.on('success', function(e) {
			copyStatus.css('display', 'block');
			copyStatus.stop().fadeOut(1000);
		});
	}
   
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			form = $('#linkForm', _this.container);
			shortLinkField = $('.state.result #shortLink', _this.container);

			// init
			initFormHandler();
			
			initClipboardHandler();
		
			shortLinkField.mouseup(function() {
				shortLinkField.select(); 
			});				

			_this.inited = true;
		}
	};
	
	
	this.resetForm = function(){
		form[0].reset();
	};
	
	
	this.reset = function(){
		_this.resetForm();
		$('.state.form').show();
		$('.state.result').hide();		
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
